module.exports = __webpack_public_path__ + "img/1510172378.1696a97d.jpg";